import React, { useEffect, useRef, useState } from 'react'
import {Radio, Tree, Menu, Layout,
  message,
  Col,
  Row,
  Pagination,
  Button,
  Input,
  Modal,
  Progress,
  ConfigProvider,
} from 'antd'

import zhCN from 'antd/lib/locale/zh_CN';
import {
  RightCircleOutlined,
  DownOutlined,
  FileTextOutlined,
  SearchOutlined,
  TeamOutlined,
  FormOutlined,
  ReadOutlined,
  CodeOutlined,
  ScheduleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  EyeOutlined,
  SyncOutlined,
  RocketOutlined,
} from '@ant-design/icons'
import projectStyles from './project.module.less'
import UserInfo from '../common/user-center/user-info'
import LoginRegisterModal, {checkIsTeacher,} from '../../component/modal/login-register/login-register'
import { Link } from 'react-router-dom'
import taskLearnStyles from '../task/task-learn.module.less'
import projectDetailStyles from './project-detail.module.less'
import noclassroom from '../../static/image/noclassroom.png'


import 'easymde/dist/easymde.min.css'

import ReactMarkdown from 'react-markdown'
import rehypeKatex from 'rehype-katex'
import { useHistory } from 'react-router-dom'
import 'katex/dist/katex.min.css' // `rehype-katex` does not import the CSS for you
import gfm from 'remark-gfm'
import remarkMath from 'remark-math'
import rehypeRaw from 'rehype-raw'
import rehypeHighlight from 'rehype-highlight'
import logoIconSvg from '../../static/image/logo-icon.svg'
import Draggable from 'react-draggable'
import { sendHttpPostRequest } from '../../api/http-request'
import Cookies from 'js-cookie'

import ProjectMyClassroom from './project-my-classroom'
import ProjectMySubmit from './project-my-submit/project-my-submit'
import { getChapterLabels } from '../common/utils/util'

import { ProjectTest } from './project-test/ProjectTest'
import MarkDownEditor from '@/pages/components/MarkdownEditor/MarkdownEditor'
import { BACKEND_API_URL } from '@/constants/constants'
import CoursePaymentModal from './components/CoursePaymentModal'
import { showAccessGuideModal } from './components/accessGuideModal'
import { getAccessGuideContentByReason } from './components/modalCopy'


const refresh_table_tds = ()=>{
  setTimeout(function(){
    const table_tds = document.getElementsByTagName("td") //以下代码设置页面表格内容属性
    console.log(table_tds)
    for(let i=0; i < table_tds.length;  i++){
        try{
          console.log(table_tds[i].innerText)
          table_tds[i].setAttribute('title', table_tds[i].innerText);
        }catch(error1){
          console.log(error1)
        }
      }
  }, 2000); //单位是毫秒
}

export interface Props {}

export const ProjectMainStudent: React.FC<Props> = (props) => {
  let location = window.location
  let projectId = parseInt(window.location.search.split('=')[1]) // 项目的ID
  if (!projectId) {
    projectId = 1
  }

  const [project, setProject] = useState(null as any)
  const [projectAccessInfo, setProjectAccessInfo] = useState(null as any)

  const [selectedTabKey, setSelectedTabKey] = useState<any>(
    location.search.includes('my_commit_record') ? ['8'] : ['1']
  ) //选中的项目菜单项
  const currentTabKey = Array.isArray(selectedTabKey)
    ? selectedTabKey[0]
    : selectedTabKey
  const isPersonalPaid =
    (projectAccessInfo?.pay_reason || project?.access_info?.pay_reason) ===
    'personal_paid'



  const [testList, setTestList] = useState(null as any) //技能检测习题列表


  const [inClassVisible, setInClassVisible] = useState(false)
  const [
    inputClassPasswordModalVisible,
    setInputClassPasswordModalVisible,
  ] = useState(false) //输入教室密码弹出框
  const [joinClassError, setJoinClassError] = useState('')  // 加入班级内联错误提示
  const [coursePaymentVisible, setCoursePaymentVisible] = useState(false)
  const [pendingAccessInfo, setPendingAccessInfo] = useState(null as any)

  const [collegeId, setCollegeId] = useState(null as any) // 院校ID


  const [userInfo, setUserInfo] = useState(null as any) //当前用户的信息
  const [realName, setRealName] = useState(null as any) //保存当前学生真实姓名
  const [realNumber, setRealNumber] = useState(null as any) //学号

  const pageClassRoom = useRef(1) // 记录当前的页数
  const pageSizeClassRoom = useRef(6) // 记录当前每页展示数量
  const [resultSumClassRoom, setResultSumClassRoom] = useState(null as any)
  const [projectClassRoomList, setProjectClassRoomList] = useState(null as any) //保存教室查询列表
  const queryClassRoomContent = useRef('') //教室查询

  const page = useRef(1) //当前学生页
  const pageSize = useRef(15) //每页学生数量
  const queryStudentContent = useRef('') //查询字符串

  const [classRoomInfo, setClassRoomInfo] = useState(null as any) //班级信息

  const selectedClassRoomId = useRef(null as any) //当前选中的教室ID
  const [selectedClassRoom, setSelectedClassRoom] = useState(null as any) //当前选中的教室
  const inputClassRoomPassword = useRef(null as any) //当前用户输入的教室密码

  const draggleRef = useRef<HTMLDivElement | null>(null)

  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const [disabled, setDisabled] = useState(true)

  const onStart = (event: any, uiData: any) => {
    const { clientWidth, clientHeight } = window?.document?.documentElement
    const targetRect = draggleRef?.current?.getBoundingClientRect()
    if (targetRect) {
      setBounds({
        left: -targetRect?.left + uiData?.x,
        right: clientWidth - (targetRect?.right - uiData?.x),
        top: -targetRect?.top + uiData?.y,
        bottom: clientHeight - (targetRect?.bottom - uiData?.y),
      })
    }
  }

  const showAccessGuide = (accessInfo: any) => {
    setPendingAccessInfo(accessInfo || {})
    const payReason = accessInfo?.pay_reason
    const content = getAccessGuideContentByReason(
      payReason,
      '当前项目不可访问，可加入机构使用授权，或个人付费继续使用。'
    )
    showAccessGuideModal({
      accessInfo,
      content,
      onPersonalPay: () => {
        setCoursePaymentVisible(true)
      },
    })
  }

  
 

  useEffect(() => {

    sendHttpPostRequest(
      //获取院校身份信息
      'account/api/query_teacher_authenticate',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      (response: any) => {
        if (response.is_ok == true) {
          if (response?.college_id > 0) {
            //已加入机构
            let _collegeId = response.college_info.college_id
            setCollegeId(_collegeId)
            queryProject(_collegeId)
            const isCollegeTeacher =
              response.college_info?.is_college_teacher == 1
            if (isCollegeTeacher == true) {
              //是院校老师
              window.location.href = '/project_main?project_id=' + projectId
            }
          } else {
            setCollegeId(0)
            queryProject(0)
          }
        }
      }
    )

    queryUserInfo()
  }, [])

  /**
   * 查询项目
   */
  const queryProject = (college_id) => {
    sendHttpPostRequest(
      'course/api/query_project_by_id',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        project_id: projectId,
        college_id: college_id,
        _key: currentTabKey,
      },
      (response: any) => {
        // console.log(response)
        message.destroy()
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.is_ok == true) {
          // 成功
          const accessInfo = response?.query_info?.access_info || {}
          setProjectAccessInfo(accessInfo)
          if (accessInfo?.can_access == true) {
            setProject(response.query_info)
            setTestList(
              typeof response.query_info.test_exercise_list == 'object'
                ? response.query_info.test_exercise_list
                : JSON.parse(response.query_info.test_exercise_list)
            )
            if (response.query_info?.classroom_id !== 0) {
              //如果在某个教室，则查询教室信息
              //setClassroomId(response.query_info?.classroom_id)
              queryClassRoomInfo(response.query_info?.classroom_id, college_id)
              queryProjectClassRoomList(projectId, college_id, false)
            }

            if (
              response._key &&
              !location.search.includes('my_commit_record')
            ) {
              if (accessInfo?.pay_reason === 'personal_paid' && response._key == '6') {
                setSelectedTabKey('3')
              } else {
                setSelectedTabKey(response._key)
              }
            }
          } else {
            setProject(response.query_info)
            setSelectedTabKey('3')
            showAccessGuide(accessInfo)
          }
        }  else {
          message.error(response.message)
        }
      }
    )
  }

  // 查询用户信息回调
  const queryUserInfoCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
    } else if (response.code == 0) {
      setUserInfo(response.data)
      setRealName(response.data.real_name)
      setRealNumber(response.data.number)
    } else {
      message.error(response.message)
    }
  }

  /** 查询班级信息 */
  const queryClassRoomInfo = (classroom_id, college_id) => {
    sendHttpPostRequest(
      'classroom/api/user_query_classroom_by_id/',
      {
        sessionid: Cookies.get('sessionid'),
        classroom_id: classroom_id,
        college_id: college_id,
        course_id: projectId,
        query: queryStudentContent.current,
        page: page.current,
        pagesize: pageSize.current,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.is_ok == true) {
          setClassRoomInfo(response.query_info)
          //setClassStudentList(response.query_info.student_list)
          //setCurrentClassRoomName(response.query_info.name)
        } /*else if (response.code == -501) {
                        权限不足
                        window.location.href = '/oam_login?next=oam_menu';
                    } */ else {
          message.error(response.message)
        }
      }
    )
  }

  // 查询用户信息
  const queryUserInfo = () => {
    sendHttpPostRequest(
      'account/api/get_user_info/',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      queryUserInfoCallback
    )
  }

  // tab页缓存
  const cacheTabPage = (key: any) => {
    sendHttpPostRequest(
      'course/api/cache_project_tab_page/',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        project_id: projectId,
        _key: key,
      },
      (response: any) => {
        if (response.code == -100) {
          document.getElementById('show-login-modal')!.click()
        }
        // if (response._key) {
        //     setSelectedTabKey(response._key);
        // }
      }
    )
  }


  /** 查询当前学生所在机构的某个项目的所有教室列表 */
  const queryProjectClassRoomList = (projectId, collegeID, showModal) => {
    sendHttpPostRequest(
      'classroom/api/user_query_classroom_list/',
      {
        sessionid: Cookies.get('sessionid'),
        course_id: projectId,
        college_id: collegeID,
        query: queryClassRoomContent.current,
        page: pageClassRoom.current,
        pagesize: pageSizeClassRoom.current,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.is_ok == true) {
          setProjectClassRoomList(response.query_list)
          setResultSumClassRoom(response.total_sum)

          if (showModal == true) {
            setInClassVisible(true)
          }
        } /*else if (response.code == -501) {
                        权限不足
                        window.location.href = '/oam_login?next=oam_menu';
                    } */ else {
          message.error(response.message)
        }
      }
    )
  }

  // 保存用户信息回调
  const saveUserInfoCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
    } else if (response.code == 0) {
      message.success('更新用户信息成功')
      // 重设localStorage
      //queryUserInfo();
      sendHttpPostRequest(
        'classroom/api/user_swift_classroom/',
        {
          sessionid: Cookies.get('sessionid'),
          classroom_id: classRoomInfo?.id,
          new_classroom_id: selectedClassRoomId.current,
          password: inputClassRoomPassword.current,
        },
        (response: any) => {
          message.destroy()
          if (response.code == -100) {
            // 未登录
            document.getElementById('show-login-modal')!.click()
          } else if (response.is_ok == true) {
            message.success('加入教室成功~')
            //window.location.href  = '/project_main_student?project_id=' + projectId;
            setInputClassPasswordModalVisible(false)
            setInClassVisible(false)
            // queryClassRoomInfo(response.classroom_id,collegeId)
            queryProject(collegeId)
            setTimeout(() => {
              window.location.reload()
            }, 200)
          } /*else if (response.code == -501) {
                                权限不足
                                window.location.href = '/oam_login?next=oam_menu';
                            } */ else {
            setJoinClassError(response.message || '加入班级失败，请重试')
          }
        }
      )
    } else {
      setJoinClassError(response.message || '保存用户信息失败，请重试')
    }
  }

  // 保存用户信息
  const saveUserInfo = () => {
    sendHttpPostRequest(
      'account/api/update_user_info/',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        user_id: userInfo?.user_id,
        real_name: realName,
        number: realNumber,
        nick_name: userInfo?.nick_name,
      },
      saveUserInfoCallback
    )
  }

  //教室页码和页数发生了变化
  const onClassRoomPageChange = (
    newPage: number,
    newPageSize?: number | undefined
  ) => {
    pageClassRoom.current = newPage ? newPage : 1
    if (newPageSize) {
      pageSizeClassRoom.current = newPageSize
    }
    queryProjectClassRoomList(projectId, collegeId, false)
  }

  /** 学生加入某个班级 */
  const onConfirmInputClass = () => {
    setJoinClassError('')
    if (realName?.trim() == '') {
      setJoinClassError('真实姓名不能为空~')
      return ''
    }

    if (realNumber?.trim() == '') {
      setJoinClassError('学号不能为空~')
      return ''
    }

    saveUserInfo()
  }


  const handleClick = (e: any) => {
    const canAccess = projectAccessInfo?.can_access == true
    const lockedTabKeys = ['2', '4', '5', '6', '7', '8']
    if (!canAccess && lockedTabKeys.includes(e.key)) {
      showAccessGuide(projectAccessInfo || project?.access_info || {})
      return
    }
    setSelectedTabKey(e.key)
    cacheTabPage(e.key)
    refresh_table_tds()
  }


  interface Props3 {
    title: any
    content: any
  }
  const AimModule: React.FC<Props3> = (props) => {
    return (
      <div className={projectStyles.aimDivWrapper}>
        <div className={projectStyles.aimDivHeader}>{props.title}</div>
        <div className={projectStyles.aimDivContent}>{props.content}</div>
      </div>
    )
  }

  interface Props2 {}


//项目介绍
  const ProjectIntroduction: React.FC<Props2> = (props) => {
    return (
      <div className={projectStyles.aimWrapper}>

        {/* Hero Banner */}
        <div className={projectDetailStyles.introHeroBanner}>
          <div className={projectDetailStyles.introHeroContent}>
            <div className={projectDetailStyles.introHeroTitle}>实训目标</div>
            <div className={projectDetailStyles.introHeroAim}>{project?.aim}</div>
          </div>
          <div className={projectDetailStyles.introHeroMeta}>
            <span className={projectDetailStyles.introHeroMetaItem}>
              <ClockCircleOutlined style={{marginRight:6}} />{project?.teaching_duration} 课时
            </span>
          </div>
        </div>

        {/* 项目介绍 - 全宽大卡片 */}
        <AimModule
          title="项目介绍"
          content={
            <ReactMarkdown
              className={projectDetailStyles.reactmarkdownProjectIntro}
              remarkPlugins={[gfm, remarkMath]}
              rehypePlugins={[rehypeHighlight, rehypeKatex, rehypeRaw]}
            >
              {project?.description}
            </ReactMarkdown>
          }
        />

        {/* 实践工具 & 前置基础 — 双列网格 */}
        <Row gutter={[24, 24]}>
          <Col xs={24} md={12}>
            <AimModule title="实践工具" content={
              <div style={{ padding:12, display:'flex', flexWrap:'wrap', gap:8 }}>
                {project?.tools?.split(';')?.map((tool, toolInd) => (
                  <span key={toolInd} className={projectStyles.projectTool} title={tool}>{tool}</span>
                ))}
              </div>
            } />
          </Col>
          <Col xs={24} md={12}>
            <AimModule title="前置基础" content={
              <div style={{ padding:12, display:'flex', flexWrap:'wrap', gap:8 }}>
                {project?.preconditions?.split(';')?.map((skill, skillInd) => (
                  <span key={skillInd} className={projectStyles.projectSkill} title={skill}>{skill}</span>
                ))}
              </div>
            } />
          </Col>
        </Row>

      </div>
    )
  }
// 项目任务
  const ProjectTask: React.FC<Props2> = (props) => {
    const [menu, setMenu] = useState(null as any)
    const chapterId2Start = useRef(null as any)
    const taskId2Start = useRef(null as any)

    /**
     * 查询大纲
     */
    useEffect(() => {
      queryMenu() //
    }, [])

 

    /**
     * 开始章节实训回调
     * @param response
     */
    const startChapterCallback = (response: any) => {
      // console.log(response)
      message.destroy()
      if (response.code == -100) {
        // 未登录
        document.getElementById('show-login-modal')!.click()
      } else if (response.is_ok == true) {
        window.open(
          '/task_learn?project/' +
            project?.id +
            '/chapter/' +
            chapterId2Start.current +
            '/task/' +
            response.exercise_id +
            '/'
        )
      } /*else if (response.code == -501) {
                权限不足
                window.location.href = '/oam_login?next=oam_menu';
            } */ else {
        message.error('开始实训遇到问题！~')
      }
    }
    const queryMenu = () => {
      sendHttpPostRequest(
        'course/api/query_course_submission',
        {
          sessionid: Cookies.get('sessionid'),
          course_id: project.id,
        },
        queryMenuCallback
      )
    }

    /**
     * 查询大纲回调
     * @param response
     */
    const queryMenuCallback = (response: any) => {
      console.log(response)
      message.destroy()
      if (response.code == -100) {
        // 未登录
        document.getElementById('show-login-modal')!.click()
      } else if (response.is_ok == true) {
        setMenu(response.menu)
      } /*else if (response.code == -501) {
                权限不足
                window.location.href = '/oam_login?next=oam_menu';
            } */ else {
        message.error(response.message)
      }
    }

    const goTaskLearn = (chapterId: number, task: any) => {
      if (task?.pay_locked == 1) {
        showAccessGuide(project?.access_info || {})
        return
      }
      window.open(
        '/task_learn?project/' +
          project?.id +
          '/chapter/' +
          chapterId +
          '/task/' +
          task?.id +
          '/'
      )
    }

    return (
      <div
        className={projectStyles.aimWrapper}
        style={{
          minHeight:700,
        }}
      >
        {menu?.map((chapter, chapterIndx) => {
          return (
            <AimModule
              key={chapterIndx}
              title={
                <>
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: 10,
                      width: 28,
                      height: 28,
                      borderRadius: 8,
                      background: 'linear-gradient(135deg, #4f46e5, #6366f1)',
                      color: '#fff',
                      fontSize: 14,
                      fontWeight: 700,
                      flexShrink: 0,
                    }}
                  >
                    {getChapterLabels(chapterIndx)}
                  </span>
                  {chapter.name}
                </>
              }
              content={
                <div>
                  {' '}
                  <ReactMarkdown
                    className={projectStyles.reactmarkdownProjectIntro}
                    remarkPlugins={[gfm, remarkMath]}
                    rehypePlugins={[rehypeHighlight, rehypeKatex, rehypeRaw]}
                  >
                    {chapter.description}
                  </ReactMarkdown>

                                    <div style={{margin:'12px 0'}}>
                  {chapter?.tasks?.map((task, taskInd)=>(
                    <Row key={taskInd} wrap = {false} className={projectStyles.taskDiv} align={'middle'}
                    
                    style={{cursor: task?.pay_locked == 1 ? 'not-allowed' : 'pointer', opacity: task?.pay_locked == 1 ? 0.72 : 1}}
                    onClick={()=>{goTaskLearn(chapter.id, task)}}
                    >
                      <Col flex={'100px'}>
                          <div> 
                            { task?.status == 1 && <span style={{padding:'8px 12px', borderRadius:999, background:'#Ef44441a', color:'#Ef4444',fontWeight:500}}> <CloseCircleOutlined /> 未通过</span>}
                            { task?.status == 0 && <span style={{padding:'8px 12px', borderRadius:999, background:'#f3f4f6', color:'#4b5563',fontWeight:500}} > <ClockCircleOutlined /> 未开始</span>}
                            { task?.status == 2 && <span style={{padding:'8px 12px', borderRadius:999, background:'rgb(16 185 129 / 0.1)', color:'rgb(16 185 129)',fontWeight:500}} ><CheckCircleOutlined /> 已通过</span>}
                          </div>
                      </Col>

                      <Col flex={'auto'}>
                          <div style={{fontSize:16, fontWeight:500, color:'#4b5563'}}> {String(chapterIndx+1)}{'.'}{String(taskInd+1)} {' '}{task?.pay_locked == 1 ? '[锁定] ' : ''}{task?.name} </div>
                      </Col>

                      <Col flex={'150px'} style={{textAlign:'right'}}>
                          <div style={{textAlign:'right'}}> 
                            <span className={projectStyles.projectLookover} 
                            onClick={(e)=>{e.preventDefault(); e.stopPropagation(); goTaskLearn(chapter.id, task)}}
                          >{task?.pay_locked == 1 ? '去开通' : task?.status == 2?<><EyeOutlined style={{marginRight:5}} />查看任务</>:task?.status == 1?<><SyncOutlined style={{marginRight:5}}  />重新尝试</>:<><RocketOutlined  style={{marginRight:5}}  rotate={45}/>开始任务</>} </span> </div>
                      </Col>

                    </Row>
                  ))
                  }
                   </div>
                </div>
              }
            />
          )
        })}
      </div>
    )
  }

  /** 学生报告标签页  我的报告*/
  const ProjectReport: React.FC<Props2> = (props) => {
    const [reportNode, setReportNode] = useState(null as any) //当前报告节点
    const [report, setReport] = useState(null as any) //项目报告
    const [userNodeContent, setUserNodeContent] = useState(null as any) //记录当前节点用户输入的内容

    const nodeId = useRef(null as any) //当前节点ID
    const chapterInd = useRef(0) //当前章节索引
    const nodeInd = useRef(0) //当前节点索引

    const [task, setTask] = useState(null as any) //记录当前节点对应的任务，如果有任务


    const [projectMenu, setProjectMenu] = useState([] as any[]) //项目的大纲

    const animationTimer = useRef<any>()

    useEffect(() => {
      window.onload = function(){
        try{
          refresh_table_tds()
        }catch(error){
          console.log(error)
        }
      } 

      queryProjectReport()
      queryProjectMenu()
    }, [])

    /** 从项目大纲中查找章Id */
    const getChapterIdByTaskId = (taskId) => {
      let result = null
      projectMenu?.map((chapter, chapterInd) => {
        chapter?.tasks.map((item) => {
          if (item.id == taskId) {
            result = chapter.id
          }
        })
      })
      return result
    }

    /** 从项目大纲中查找章和节索引 */
    const getChapterTaskIndByTaskId = (taskId) => {
      let result = { chapterInd: -1, taskInd: -1, taskName: '' }
      projectMenu?.map((chapter, chapterInd) => {
        chapter?.tasks.map((item, itemInd) => {
          if (item.id == taskId) {
            result.chapterInd = chapterInd
            result.taskInd = itemInd
            result.taskName = item.name
          }
        })
      })
      return (
        result.chapterInd +
        1 +
        '.' +
        (result.taskInd + 1) +
        ' ' +
        result.taskName
      )
    }

    /** 查询项目的大纲 */
    const queryProjectMenu = () => {
      sendHttpPostRequest(
        'course/api/query_chapter_list',
        {
          sessionid: Cookies.get('sessionid'),
          course_id: project.id,
        },
        (response: any) => {
          message.destroy()
          if (response.code == -100) {
            // 未登录
            document.getElementById('show-login-modal')!.click()
          } else if (response.is_ok == true) {
            // 成功

            setProjectMenu(response.menu)
          } else {
            message.error(response.message)
          }
        }
      )
    }

    // 查询报告大纲
    const queryProjectReport = () => {
      sendHttpPostRequest(
        'report/api/user_query_with_simple_report_task_submission/',
        {
          sessionid: Cookies.get('sessionid'),
          sid: Cookies.get('sessionid'),
          report_id: project?.report_id,
          course_id: projectId,
        },
        (response: any) => {
          if (response.code == -100) {
            // 未登录
            document.getElementById('show-login-modal')!.click()
          } else if (response.is_ok == true) {
            setReport(response.query_info)
            if (reportNode == null) {
              if (response.query_info?.json?.length > 0) {
                if (response.query_info?.json[0].tasks.length > 0) {
                  queryReportNode(response.query_info?.json[0].tasks[0].id)
                }
              }
            }
          }
        }
      )
    }

    // 查询报告节点
    const queryReportNode = (nodeId) => {
      sendHttpPostRequest(
        'report/api/user_query_node/',
        {
          sessionid: Cookies.get('sessionid'),
          sid: Cookies.get('sessionid'),
          node_id: nodeId,
        },
        (response: any) => {
          if (response.code == -100) {
            // 未登录
            document.getElementById('show-login-modal')!.click()
          } else if (response.is_ok == true) {
            setReportNode(response.query_info)
            setUserNodeContent(response.query_info.content)
            if (response.query_info.exercise_id !== '' && response.query_info.exercise_id !== 0) {
              queryTaskInfo(response.query_info.exercise_id) //如果当前包含任务，则将当前用户的结果显示。
            }
          }
        }
      )
    }

    // 保存用户撰写的报告内容
    const saveNodeUserContent = (showMessage) => {
      sendHttpPostRequest(
        'report/api/user_write_report_node/',
        {
          sessionid: Cookies.get('sessionid'),
          sid: Cookies.get('sessionid'),
          node_id: reportNode?.id,
          course_id: projectId,
          content: userNodeContent,
        },
        (response: any) => {
          if (response.code == -100) {
            // 未登录
            document.getElementById('show-login-modal')!.click()
          } else if (response.is_ok == true) {
            if(showMessage){
              message.success('报告内容保存成功~')
            }
            queryProjectReport()
          } else {
            if(showMessage){
              message.error('报告内容保存失败！')
            }
          }
        }
      )
    }

    // 查询任务详情
    const queryTaskInfo = (taskId) => {
      let params = {
        exercise_id: taskId,
        sessionid: Cookies.get('sessionid'),
      }

      sendHttpPostRequest(
        'exercise/api/query_task_by_id/',
        params,
        queryTaskCallback
      )
    }

    const queryTaskCallback = (response) => {
      message.destroy()
      if (response.code == -100) {
        // 未登录
        document.getElementById('show-login-modal')!.click()
      } else if (response.is_ok == true) {
        // 成功
        setTask(response.exercise_info)
        if (response.exercise_info.submission_info) {
          //如果结果则更新运行信息



          if (response.exercise_info.submission_info.is_html) {

            eval(response.exercise_info.submission_info.js_script)
          } else {

          }

          if (response.exercise_info.submission_info.submission_image)

            if (response.exercise_info.submission_info.is_animation) {
              clearInterval(animationTimer.current)
              let imgs = response.exercise_info.submission_info.submission_image
              let n = 0
              animationTimer.current = setInterval(function () {
                let imgContain: any =
                  document.getElementById('animation_img') &&
                  document.getElementById('animation_img')
                if (imgContain) {
                  imgContain.src = 'data:image/jpg;base64,' + imgs[n]
                  n = n + 1
                  if (n >= imgs.length) {
                    n = 0
                  }
                }
              }, 100)
            }
        } else {
          //如果没有运行结果，则清空运行信息

        }
      } else {
        message.error(response.message)
      }
    }

    /** 将报告大纲转成菜单控件的输入格式 */
    const getTreeData = () => {
      const treeData = [] as any[] //
      report?.json?.map((chapter, chapterInd) => {
        const treeChapter = {
          key: 'chapter_' + chapter.id,
          title: getChapterLabels(chapterInd) + ' ' + chapter.name,
          exercise_id: '',
          node_complete: -1,
          selectable: false,
          children: [] as any[],
        }
        chapter.tasks?.map((node, nodeInd) => {
          treeChapter.children.push({
            key: 'node_' + node.id,
            title:
              String(chapterInd + 1) +
              '.' +
              String(nodeInd + 1) +
              ' ' +
              node.name,
            node_complete: node.node_complete,
            chapterId: chapter.id,
            chapterInd: chapterInd,
            nodeInd: nodeInd,
            exercise_id: node.exercise_id,
          })
        })
        treeData.push(treeChapter)
      })
      return treeData
    }


      /** 用户输入节点报告内容变化 */
      const onUserNodeContentMDChange = (value: any) => {
        // save_note()
        setUserNodeContent(value.text)
      }

    const handleReportNodeSelected = (selectedKeys: any, object: any) => {
      saveNodeUserContent(false) // 先保存填写的内容
      //处理通过报告大纲菜单选择了某一个节点事件
      if (selectedKeys[0]?.split('_')?.length > 1) {
        nodeId.current = selectedKeys[0].split('_')[1]
        nodeInd.current = object.node.nodeInd
        chapterInd.current = object.node.chapterInd
        queryReportNode(nodeId.current)
        document.getElementById("nodeReportWrapper").scrollTop = 0 //TODO
        refresh_table_tds()
      }
    }
    /** 上一个报告节点 */
    const preNode = (e: any) => {
      saveNodeUserContent(false)
      if (nodeInd.current == 0) {
        chapterInd.current = chapterInd.current - 1
        nodeInd.current = report?.json[chapterInd.current].tasks?.length - 1
      } else {
        nodeInd.current = nodeInd.current - 1
      }

      queryReportNode(
        report?.json[chapterInd.current].tasks[nodeInd.current].id
      )
      document.getElementById("nodeReportWrapper").scrollTop = 0 //TODO
      refresh_table_tds()
    }
    /** 下一个报告节点 */
    const nextNode = (e: any) => {
      saveNodeUserContent(false)
      if (
        nodeInd.current ==
        report?.json[chapterInd.current].tasks?.length - 1
      ) {
        chapterInd.current = chapterInd.current + 1
        nodeInd.current = 0
      } else {
        nodeInd.current = nodeInd.current + 1
      }

      queryReportNode(
        report?.json[chapterInd.current].tasks[nodeInd.current].id
      )
      document.getElementById("nodeReportWrapper").scrollTop = 0 //TODO
      refresh_table_tds()
    }

    return (
      <Row
        wrap={false}
        className={projectStyles.aimDivWrapper}
         style={{marginBottom:0,height: 'calc(100vh - 132px)'}}
        
      >
        <Col
          flex="auto"
          style={{
            minWidth: 400,
            minHeight: 700,
          }}
        >

          <Row
            style={{
              paddingBottom: 12,
              position:'sticky',
              top: 0,
              zIndex: 10,
              background:'linear-gradient(180deg, #fff 80%, rgba(255,255,255,0))',
              borderBottom: '1px solid #f3f4f6',
              marginBottom: 8,
            }}
            justify="space-between"
            align={'middle'}
            wrap={false}
          >
            <Col flex={'auto'}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                }}
              >
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 32, height: 32,
                  borderRadius: 8,
                  background: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
                  color: '#fff',
                  fontSize: 13,
                  fontWeight: 700,
                  flexShrink: 0,
                }}>
                  {chapterInd.current + 1}.{nodeInd.current + 1}
                </span>
                <div
                  style={{
                    fontSize: 18,
                    fontWeight: 600,
                    color: '#1f2937',
                    whiteSpace:'nowrap',
                    overflow:'hidden',
                    textOverflow:'ellipsis'
                  }}
                >
                  {reportNode?.name}
                </div>
              </div>
            </Col>

            <Col flex={'320px'} style={{textAlign:'right'}}>
              <div style={{display:'flex', justifyContent:'flex-end', gap:8}}>
                <Button
                  style={{
                    borderRadius: 8, width: 88, height: 36, fontSize: 14,
                    color: '#4f46e5', backgroundColor: '#eef2ff', border: '1px solid #c7d2fe',
                  }}
                  disabled={(nodeInd.current == 0 && chapterInd.current == 0)}
                  onClick={preNode}
                >
                  上一步
                </Button>
                <Button
                  style={{
                    borderRadius: 8, width: 88, height: 36, fontSize: 14,
                    color: '#4f46e5', backgroundColor: '#eef2ff', border: '1px solid #c7d2fe',
                  }}
                  disabled={
                    (nodeInd.current ==
                      report?.json[chapterInd.current]?.tasks?.length - 1 &&
                      chapterInd.current == report?.json?.length - 1)
                  }
                  onClick={nextNode}
                >
                  下一步
                </Button>
                <Button
                  type="primary"
                  style={{
                    borderRadius: 8, width: 88, height: 36, fontSize: 14,
                    backgroundColor: '#4f46e5',
                  }}
                  onClick={() => {
                    saveNodeUserContent(true)
                  }}
                >
                  保存
                </Button>
              </div>
            </Col>
          </Row>


          <div
            className={projectStyles.nodeReportWrapper}
            style={{
              overflowY: 'auto',
              height: 'calc(100vh - 250px)',
              minHeight:550,
              paddingBottom: 300,
            }}
          >
            <div className={projectStyles.nodeDesImage}>
              <ReactMarkdown
                className={taskLearnStyles.reactmarkdown}
                remarkPlugins={[gfm, remarkMath]}
                rehypePlugins={[rehypeHighlight, rehypeKatex, rehypeRaw]}
              >
                {reportNode?.description}
              </ReactMarkdown>
 

            </div>

            {reportNode?.exercise_id !== '' && reportNode?.exercise_id !== 0 && reportNode?.type == 1 &&
               (

                <div style={{paddingTop:10, paddingBottom:10, borderRadius: 12,  background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)', border: '1px solid #e2e8f0', fontSize: 14  }}>
                {task?.submission_info?.submission_id !== 0 && (
                  <div >
                     <div style={{maxHeight:400, overflowY:'scroll'}}>
                        {task?.submission_info?.is_html == true && (
                          <div style={{color:'#333', marginLeft: 20,marginRight: 20, display: 'flex',justifyContent: 'center',overflow: 'auto',backgroundColor: '#fff',}}
                            dangerouslySetInnerHTML={{__html: task.submission_info.submission_output?.replaceAll('\n',''),}}
                          />
                        )}

                        {task?.submission_info?.is_html == false && !task?.submission_info?.is_table && (
                            <div style={{marginLeft: 20,marginRight: 20,marginBottom: 10,paddingTop: 0,borderRadius: 5,}}
                             
                            >
                              <ReactMarkdown
                                className={projectStyles.reactmarkdown}
                                remarkPlugins={[gfm, remarkMath]}
                                rehypePlugins={[
                                  rehypeHighlight,
                                  rehypeKatex,
                                  rehypeRaw,
                                ]}
                                >
                                {
                                  task?.submission_info?.submission_output.replaceAll('\n', '\n\n')
                                }
                                </ReactMarkdown>
                            </div>
                        )}

                        {/* 如果是表格字符串  单独处理 */}
                        {task?.submission_info?.is_html == false && task?.submission_info?.output_table_str && task?.submission_info?.is_table && (
                            <div  style={{marginLeft: 20,marginRight: 20,marginBottom: 10,paddingTop: 0,borderRadius: 5,}}
                              dangerouslySetInnerHTML={{__html:task?.submission_info?.output_table_str,}}
                            ></div>
                        )}
                      </div>

                      <div>
                      {task?.submission_info?.submission_image && !task?.submission_info?.is_animation && task?.submission_info?.submission_image?.map(
                            (iamgeBase64, ind) => {
                              return (
                                <div style={{margin: 10,textAlign: 'center',}}
                                  key={String(ind)}
                                >
                                  <img src={'data:image/jpg;base64,' +iamgeBase64} style={{maxHeight:300, backgroundColor: '#fff',borderRadius: 3,}}></img>
                                </div>
                              )
                            }
                          )}

                        {task?.submission_info?.submission_image && task?.submission_info?.is_animation && 
                          <div style={{margin: 10,textAlign: 'center',}}>
                            <img 
                              style={{ maxWidth:'100%'}}
                              id="animation_img"
                              src={
                                'data:image/jpg;base64,' + task.submission_info.submission_image &&
                                task.submission_info.submission_image[0]
                              }
                              alt=""
                            />
                            </div>
                        
                        }
                      </div>
  
                  </div> )}

                  {
                  task?.submission_info?.submission_id !== 0 && (
                  <div style={{ marginTop:10, color: '#999999', textAlign: 'right' }}>
                      （结果由任务{' '}{getChapterTaskIndByTaskId(reportNode?.exercise_id)} 生成）
                    </div> )}

                  {/** 以下是任务没提交 */}
                  {
                    task?.submission_info?.submission_id == 0 && (
                      <div 
                        style={{paddingTop: 24, paddingBottom:24, marginBottom: 10, textAlign: 'center', cursor: 'pointer', color:'#4f46e5', transition: 'all 0.2s'}}
                        onClick={() => {window.open(`task_learn?project/${projectId}/chapter/${getChapterIdByTaskId(reportNode?.exercise_id)}/task/${reportNode?.exercise_id}/`)
                        }}
                      >
                        <RightCircleOutlined
                          style={{ fontSize: 28, marginBottom: 6 }}
                        />
                        <div style={{fontSize: 14, fontWeight: 500}}>
                          本结果由任务{' '}{getChapterTaskIndByTaskId(reportNode?.exercise_id)}{' '}自动生成
                        </div>
                        <div style={{fontSize: 13, color: '#9ca3af', marginTop: 4}}>您尚未完成该任务，点击前往</div>
                      </div>
                    )}


              </div> //taskRungingOutputDiv -结束
 

              )}
          {reportNode?.need_input_info == 2 && (
              <div style={{marginTop:10}}>
                <div id="input-info" style={{ marginBottom: 10 }} className={projectStyles.reportInputTitle}>
                  {reportNode?.input_info}
                </div>

                <div
                  id="user-input-content"
                  className={projectStyles.userReportContentWrapper}
                  style={{borderRadius:8, border:'1px solid #e5e7eb'}}
                >

                <MarkDownEditor
                      preview={false}
                      placeholder="请输入您的分析内容"
                      onChange={onUserNodeContentMDChange}
                      value={userNodeContent}
                      toolbar={'note'}
                      onBlur={() => {} }
                    />

                </div>
          </div>

           )}

           </div>

        </Col>
        <Col
          flex="300px"
          style={{
            position: 'relative',
            marginLeft: 16,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >

        <div style={{
          marginBottom:16,
          display: 'flex',
          gap: 8,
          flexShrink: 0,
        }}>
            <Button
              type="primary"
              style={{
                flex: 1,
                borderRadius: 8,
                backgroundColor: '#4f46e5',
                height: 36,
                fontSize: 14,
              }}
              onClick={() => {
                window.open(`/report_preview_my?project_id=${projectId}`)
              }}
            >
              预览报告
            </Button>
        </div>

           <div style={{
             padding: '14px 16px',
             borderRadius: 12,
             background: 'linear-gradient(135deg, #f5f3ff 0%, #eef2ff 100%)',
             border: '1px solid #e0e7ff',
             marginBottom: 16,
             flexShrink: 0,
           }}>
             <Row wrap={false} align={'middle'}>
               <Col flex="auto">
                 <div style={{fontSize: 14, fontWeight: 600, color: '#374151'}}>完成进度</div>
               </Col>
               <Col flex="80px" style={{textAlign:'right', paddingRight:4}}>
                 <span style={{fontSize: 20, fontWeight: 700, color: '#4f46e5'}}>{report?.report_complete_percent || 0}%</span>
               </Col>
             </Row>
             <div style={{marginTop: 8}}>
               <Progress showInfo={false} strokeColor='#4f46e5' trailColor={'#e0e7ff'} percent={report?.report_complete_percent} size="small" />
             </div>
           </div>

           <div style={{fontSize: 13, fontWeight: 600, color: '#6b7280', marginBottom: 8, letterSpacing: 1, textTransform: 'uppercase', flexShrink: 0}}>报告大纲</div>

          <Row
            align="middle"
            justify="start"
            className={projectStyles.testWrapper}
            style={{overflowY: 'auto', overflowX: 'hidden', flex: 1, minHeight: 0}}
          >
            <div
              style={{ width: '100%' }}
              className={projectStyles.menuTree}
            >
              {reportNode && report?.json && (
                <Tree
                  autoExpandParent={true}
                  switcherIcon={<DownOutlined />}
                  showIcon={false}
                  selectedKeys={['node_' + reportNode?.id]}
                  blockNode={true}
                  treeData={getTreeData()}
                  defaultExpandAll={true}
                  onSelect={handleReportNodeSelected.bind(this)}
                  titleRender={(nodeData) => (
                    <Row justify="start" align="middle" gutter={[4, 4]} style={{ height: 20 }}>
                      <Col span={24}> 
                        <span style={{display: 'inline-block',overflow:'hidden', textOverflow:'ellipsis', whiteSpace: "nowrap", maxWidth:290}}>
                          {(nodeData as any).node_complete == 1 &&  <span className= {projectStyles.taskCompleteSpan}  />}
                          {(nodeData as any).node_complete == 0 &&  <span className= {projectStyles.taskUncompleteSpan}  />}
                          {nodeData.title}
                        </span>
                      </Col>
                    </Row>
                  )}
                />
              )}
            </div>
          </Row>


        </Col>
      </Row>
    )
  }

  /** 我的笔记汇总 */
  const ProjectMyNotes: React.FC<Props2> = (props) => {
    const [notemenu, setNoteMenu] = useState(null as any)
    const taskId = useRef(null as any) //当前任务ID
    const chapterId = useRef(null as any) //当前章节ID
    const [notes, setNotes] = useState(null as any) //用户当前选中的

    /**
     * 查询大纲
     */
    useEffect(() => {
      queryMenuNotes() //
    }, [])
    const queryMenuNotes = () => {
      sendHttpPostRequest(
        'course/api/query_my_project_notes',
        {
          sessionid: Cookies.get('sessionid'),
          project_id: project.id,
        },
        queryMenuNotesCallback
      )
    }

    /**
     * 查询大纲回调
     * @param response
     */
    const queryMenuNotesCallback = (response: any) => {
      // console.log(response)
      message.destroy()
      if (response.code == -100) {
        // 未登录
        document.getElementById('show-login-modal')!.click()
      } else if (response.is_ok == true) {
        // 成功

        setNoteMenu(response.menu)
        if (taskId.current == null)
          {
            chapterId.current = response.menu[0].id
            taskId.current = response.menu[0].tasks[0].id
          }
        queryUserTaskNote()
      } else {
        message.error(response.message)
      }
    }

     /** 将大纲转成菜单控件的输入格式 */
     const getNotesTreeData = () => {
      const treeData = [] as any[] //
      notemenu?.map((chapter, chapterInd) => {
        const treeChapter = {
          key: 'chapter_' + chapter.id,
          title: getChapterLabels(chapterInd) + ' ' + chapter.name,
          note_status:-1,
          selectable: false,
          children: [] as any[],
        }
        chapter.tasks?.map((task, taskInd) => {
          treeChapter.children.push({
            key: 'task_' + task.id,
            note_status: task.note_status,
            title:
              String(chapterInd + 1) +
              '.' +
              String(taskInd + 1) +
              ' ' +
              task.name,
            chapterId: chapter.id,
          })
        })
        treeData.push(treeChapter)
      })
      return treeData
    }

    const handleMyNoteSelected = (selectedKeys: any, object: any) => {
      //处理通过大纲菜单选择了某一个笔记事件
      queryMenuNotes() //TODO
      if (selectedKeys[0]?.split('_')?.length > 1) {
        taskId.current = selectedKeys[0].split('_')[1]
        chapterId.current = object.node.chapterId
        queryUserTaskNote()
      }
    }

    // 查询用户任务笔记
    const queryUserTaskNote = () => {
      sendHttpPostRequest(
        'course/api/query_note',
        {
          exercise_id: taskId.current,
          chapter_id: chapterId.current,
          sessionid: Cookies.get('sessionid'),
        },
        queryUserTaskNoteCallback
      )
    }

    const queryUserTaskNoteCallback = (response) => {
      message.destroy()
      if (response.code == -100) {
        // 未登录
        document.getElementById('show-login-modal')!.click()
      } else if (response.is_ok == true) {
        // 成功
        setNotes(response.content)
      } /*else if (response.code == -501) {
                // 权限不足
                window.location.href = '/oam_login?next=oam_task';
            } */ else {
        message.error(response.message)
      }
    }
    // 保存用户任务笔记
    const save_note = () => {
      sendHttpPostRequest(
        'course/api/save_note',
        {
          exercise_id: taskId.current,
          chapter_id: chapterId.current,
          content: notes,
          sessionid: Cookies.get('sessionid'),
        },
        saveUserTaskNoteCallback
      )
    }

    const saveUserTaskNoteCallback = (response) => {
      message.destroy()
      if (response.code == -100) {
        // 未登录
        document.getElementById('show-login-modal')!.click()
      } else if (response.is_ok == true) {
        // 成功
        //setNotes(response.content)
        //queryMenuNotes()
       
      }  else {
        message.error(response.message)
      }
    }

    /** 用户笔记变化 */
    const onEditMDChange = (value: any) => {
      setNotes(value.text)
      //save_note()
    }

    return (
      <div
        className={projectStyles.classroomListWarpper}
        style={{
          padding: '5px 0px 5px 0px',
          borderRadius: 10,
          margin: '15px 20px 15px 20px',
          height: 'calc(100vh - 90px)',
          minHeight:700,
        }}
      >
        <div className={projectStyles.classroomListHeader}>
          <Row align="middle" style={{ margin: 0, height: 50 }}>
            <Col span={12} style={{ fontSize: 16, textAlign: 'left' }}>
              {' '}
              我的笔记
            </Col>
            <Col span={12} style={{ textAlign: 'right' }}>
              <Button
                hidden={true}
                type="primary"
                style={{ width: 100, borderRadius: 15 }}
                onClick={() => {}}
              >
                {' '}
                导 出{' '}
              </Button>
            </Col>
          </Row>
        </div>
        <div
          style={{ height: 1, opacity: 0.5 }}
        ></div>
        <div style={{minHeight:660}}  className={projectStyles.classroomListContent}>
          <Row wrap={false} gutter={[20, 8]} style={{ margin: 0 }}>
            <Col
              //flex={250}
              style={{
                width: 300,
                //maxWidth: 250,
                height: 'calc(100vh - 180px)',
                borderRight: '1px solid rgba(24,43,43,0.5)',
              }}
            >
              <div  style={{minHeight:610, height:'calc(100vh - 180px)'}} className={projectStyles.menuTree}>
                {notemenu && (
                  <Tree
                    autoExpandParent={true}
                    switcherIcon={<DownOutlined />}
                    showIcon={false}
                    defaultSelectedKeys={['task_'+ notemenu[0].tasks[0].id]}
                    blockNode={true}
                    treeData={ getNotesTreeData()}
                    style={{ }}
                    defaultExpandAll={true}
                    onSelect={handleMyNoteSelected.bind(this)}
                    titleRender={(nodeData) => (
                      <Row justify="start" align="middle" gutter={[4, 4]}>
                        <Col span={24}> 
                          <span style={{display: 'inline-block',overflow:'hidden', textOverflow:'ellipsis', whiteSpace: "nowrap", maxWidth:220}}>
                            {(nodeData as any).note_status == 1 &&  <span className= {taskLearnStyles.taskCompleteSpan}  />}
                            {(nodeData as any).note_status == 2 &&  <span className= {taskLearnStyles.taskUncompleteSpan}  />}
                            {nodeData.title}
                          </span>
                        </Col>
                      </Row>
                    )}
                  />
                )}
              </div>
            </Col>

            <Col flex="auto" style={{ position: 'relative' }}>
  
              <div className={projectStyles.mdtextareamynotes}>
                <MarkDownEditor
                  preview={false}
                  //style={{height:'calc(100vh - 180px)'}}
                  //height={}
                  placeholder="请输入文档内容"
                  onChange={onEditMDChange}
                  value={notes}
                  // uploadOption={uploadOption}
                  toolbar={'note'}
                  onBlur={() => save_note()}
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    )
  }

  const getProjectContent = () => {
    if (currentTabKey == '2') {
      return (
        <ProjectTest
          setSelectedTabKey={setSelectedTabKey}
          selectedTabKey={selectedTabKey}
          projectId={projectId}
          testList={testList}
          setTestList={setTestList}
        />
      )
    } else if (currentTabKey == '3') {
      return <ProjectIntroduction />
    } else if (currentTabKey == '4') {
      return <ProjectTask />
    } else if (currentTabKey == '5') {
      return <ProjectReport />
    } else if (currentTabKey == '6') {
      return (
        classRoomInfo &&
        collegeId && (
          <ProjectMyClassroom
            classroom_id={classRoomInfo?.id}
            college_id={collegeId}
            course_id={projectId}
            course_name={project?.name}
            role={'student'}
          />
        )
      )
    } else if (currentTabKey == '7') {
      return <ProjectMyNotes />
    } else if (currentTabKey == '8') {
      return (<div style={{padding:24, borderRadius:12,background:'#fff', boxShadow:'0 0 transparent, 0 0 transparent, 0 4px 6px -1px rgba(0, 0, 0, .1), 0 2px 4px -2px rgba(0, 0, 0, .1)'}}><ProjectMySubmit /> </div>)
    } else {
      return <ProjectIntroduction />
    }
  }

  return (
    <Layout style={{ backgroundColor: '#f9fafb',minHeight: 820,overflowY: 'hidden'}}>
      <div className={projectStyles.headerDiv}>
        <Row
          className={projectStyles.studentHeader}
          justify="center"
          align="middle"
          wrap={true}
          style={{ backgroundColor: '#fff', height: 48, minWidth: 1450}}
        >
          <Col flex={'60px'} style={{ marginLeft: 40 }}>
            <Link to={'/projects'}>
              <img
                key={'0'}
                id={'menu-0'}
                title=""
                alt="logo"
                src={logoIconSvg}
                height={28}
              ></img>
            </Link>
          </Col>
          <Col flex="auto">
            <div style={{ color: '#1f2937', fontSize: 18,fontWeight:600 }}>
              {project?.name}
            </div>
          </Col>
          <Col flex="400px" style={{ textAlign: 'right', marginRight: 10 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 10 }}>
              {isPersonalPaid ? (
                <span
                  style={{
                    fontSize: 13,
                    fontWeight: 500,
                    color: '#0f766e',
                    background: 'linear-gradient(135deg, #ccfbf1 0%, #99f6e4 100%)',
                    border: '1px solid #5eead4',
                    borderRadius: 999,
                    padding: '4px 14px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 6,
                    letterSpacing: 0.3,
                  }}
                >
                  个人付费使用
                </span>
              ) : (
                <>
                  <span style={{
                    fontSize: 13,
                    fontWeight: 500,
                    color: '#4f46e5',
                    background: 'linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)',
                    border: '1px solid #c7d2fe',
                    borderRadius: 999,
                    padding: '4px 14px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 6,
                    letterSpacing: 0.3,
                  }}>
                    <span style={{ color: '#6366f1' }}>当前班级</span>
                    <span style={{ color: '#312e81', fontWeight: 600 }}>{classRoomInfo?.name}</span>
                  </span>
                  <Button
                    type="primary"
                    onClick={() => {
                      setInClassVisible(true)
                    }}
                    style={{
                      borderRadius: 999,
                      fontSize: 13,
                      fontWeight: 500,
                      height: 30,
                      padding: '0 16px',
                      background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
                      border: 'none',
                      boxShadow: '0 2px 6px rgba(99,102,241,0.3)',
                    }}
                  >
                    换班
                  </Button>
                </>
              )}
            </div>
          </Col>
          <Col style={{ marginRight: 40 }}>
            <LoginRegisterModal></LoginRegisterModal>
            <UserInfo></UserInfo>
          </Col>
        </Row>
      </div>

      <Row
        wrap={false}
        style={{
          height: 'calc(100vh - 48px)' ,
          minWidth:1450,
          minHeight: 765,
          margin: 0,
          backgroundColor: '#f9fafb',
        }}
      >
        <Col flex="200px">
          <div className={projectStyles.projiceMenuWrapper}>
            <Menu
              theme="light"
              selectedKeys={[currentTabKey]}
              mode="inline"
              onClick={handleClick}
            >
              <Menu.ItemGroup title="学习">
                <Menu.Item id="menu-item-3" key="3" icon={<ReadOutlined />}>
                  项目介绍
                </Menu.Item>
                <Menu.Item id="menu-item-2" key="2" icon={<FormOutlined />}>
                  检测习题
                </Menu.Item>
                <Menu.Item id="menu-item-4" key="4" icon={<CodeOutlined />}>
                  项目任务
                </Menu.Item>
                <Menu.Item id="menu-item-5" key="5" icon={<FileTextOutlined />}>
                  我的报告
                </Menu.Item>
              </Menu.ItemGroup>

              <Menu.ItemGroup title="其他">
                {!isPersonalPaid && (
                  <Menu.Item key="6" id="menu-item-7" icon={<TeamOutlined />}>
                    我的班级
                  </Menu.Item>
                )}
                <Menu.Item key="8" id="menu-item-8" icon={<ScheduleOutlined />}>
                  提交记录
                </Menu.Item>
              </Menu.ItemGroup>
            </Menu>
          </div>
        </Col>

        <Col
          flex="auto"
          style={{
            minWidth: 1200,
            position: 'relative',
            padding:'20px 28px',
            overflowY:'auto',
            maxHeight: 'calc(100vh - 52px)'
          }}
        >
          {getProjectContent()}
        </Col>
      </Row>
      <Modal
        title={
          <div
            style={{ width: '100%', cursor: 'move' }}
            onMouseOver={() => {
              if (disabled) {
                setDisabled(false)
              }
            }}
            onMouseOut={() => {
              setDisabled(true)
            }}
            onFocus={() => {}}
            onBlur={() => {}}
          >
            请选择班级
          </div>
        }
        width={916}
        closable={true}
        onCancel={()=>{setInClassVisible(false)}}
        centered={true}
        open={inClassVisible}
        bodyStyle={{ height: 610 }}
        className={projectStyles.changeClassModal}
        footer={
          <div>

            <Button
              className={projectStyles.stepsBtn}
              style={{ marginRight: 20 ,color:'#fff', background:'#4f46e5', borderColor:'#4f46e5'}}
              type="primary"
              onClick={() => {
                setInputClassPasswordModalVisible(true)
              }}
            >
              确认选择
            </Button>
            <Button
              className={projectStyles.stepsBtn}
              style={{
                marginRight: 20,
                backgroundColor: 'rgba(250,250,250,.1)',
                color: 'rgb(55 65 81)',
                border: '1px solid rgb(209 213 219)',
                //float: 'right',
              }}
              onClick={() => {
                setInClassVisible(false)
              }}
            >
              取消
            </Button>
          </div>
        }
        modalRender={(modal) => (
          <div>
            <Draggable
              disabled={disabled}
              bounds={bounds}
              onStart={(event, uiData) => onStart(event, uiData)}
            >
              <div ref={draggleRef}>{modal}</div>
            </Draggable>{' '}
          </div>
        )}
      >

          <Input
              placeholder="ID/名称/老师"
              suffix={<SearchOutlined style={{ color: '#666666' }} />}
              onChange={(e) => {
                queryClassRoomContent.current = e.target.value
              }}
              onPressEnter={(e) => {
                pageClassRoom.current =1; queryProjectClassRoomList(projectId, collegeId, false)
              }}
              style={{fontSize:16,padding:'12px 16px 12px 16px', borderRadius:8,margin:'0 24px 24px 10px', width:'calc(100% - 34px)'}}
            />

        {projectClassRoomList?.length != 0 ? (
          <div><Radio.Group
            buttonStyle="solid"
            onChange={(e: any) => {
              selectedClassRoomId.current = e.target.value.id
              setSelectedClassRoom(e.target.value)
            }}
          >
            {projectClassRoomList?.map((class_) => {
              return (
                <Radio.Button
                  key={class_.id}
                  value={class_}
                  disabled={class_.id == classRoomInfo?.id}
                >
                  <div className={projectStyles.changeClassList}>
                    <div style={{height:25}}>
                    { selectedClassRoomId.current ==class_.id && <div className={projectStyles.changeClassCheckedIcon}><CheckCircleOutlined style={{color:'#4f46e5'}} /></div>}
                    { class_.id == classRoomInfo?.id  && <div style={{textAlign:'right'}}><span className={projectStyles.currentClassSpan}>当前班级</span></div>}
                    </div>
                    <div style={{ fontSize: 18, fontWeight:600, marginBottom:4 }}>{class_.name}</div>
                    <div style={{fontSize:14, marginBottom:16, color:'rgb(107 114 128)'}}>班号： {class_.number}</div>

                    <div style={{display:'flex', alignItems:'center', gap:10, marginBottom:16, padding:'10px 12px', backgroundColor:'#f9fafb', borderRadius:10}}>
                      <img src={class_?.teacher_avatar?.startsWith("http") ? class_?.teacher_avatar : BACKEND_API_URL + class_?.teacher_avatar} style={{borderRadius:'50%', width:36, height:36, border:'2px solid #e0e7ff', flexShrink:0}} />
                      <div>
                        <div style={{fontSize:12, color:'#9ca3af', lineHeight:1}}>教师</div>
                        <div style={{fontSize:14, fontWeight:600, color:'#1f2937'}}>{class_?.teacher_real_name?class_?.teacher_real_name:class_?.user_name}</div>
                      </div>
                    </div>

                    <div style={{color:'#6b7280', fontSize:13}}>
                    <TeamOutlined  style={{marginRight:6}}/> 现有学员: {class_?.user_count} 人
                    </div>

                  </div>
                </Radio.Button>
              )
            })}
          </Radio.Group>

            <div style={{textAlign:'center'}}>
              <ConfigProvider locale={zhCN}> 
                <Pagination
                  //style={{ float: 'left' }}
                  defaultCurrent={1}
                  total={resultSumClassRoom}
                  pageSize={6}
                  current={pageClassRoom.current}
                  hideOnSinglePage={true}
                  onChange={onClassRoomPageChange}
                  showSizeChanger={false}
                  
                />
              </ConfigProvider>
            </div>

          
          </div>
        ) : (
          <div style={{ width: '100%', textAlign: 'center', color: '#ccc' }}>
            <img
              src={noclassroom}
              alt=""
              width={200}
              height={200}
              style={{ margin: '40px auto' }}
            />
            <p>你所在机构老师还未创建班级哦，请联系老师创建后使用~</p>
          </div>
        )}
      </Modal>

      <Modal
        title={
          <div
            style={{ width: '100%', cursor: 'move', color: '#1e293b' }}
            onMouseOver={() => {
              if (disabled) {
                setDisabled(false)
              }
            }}
            onMouseOut={() => {
              setDisabled(true)
            }}
            onFocus={() => {}}
            onBlur={() => {}}
          >
            加入班级:{selectedClassRoom?.name}
          </div>
        }
        width={420}
        closable={false}
        centered={true}
        open={inputClassPasswordModalVisible}
        bodyStyle={{
          padding: '20px 28px 4px',
          textAlign: 'left',
        }}
        className={projectStyles.chooseClassRoomDiv}
        footer={
          <div style={{ display: 'flex', justifyContent: 'center', gap: 12 }}>
            <Button
              className={projectStyles.stepsBtn}
              style={{ color: '#fff' }}
              type="primary"
              onClick={onConfirmInputClass}
            >
              确认
            </Button>
            <Button
              className={projectStyles.stepsBtn}
              style={{
                backgroundColor: '#f1f5f9',
                border: 0,
                color: '#475569',
              }}
              onClick={() => {
                setJoinClassError('')
                setInputClassPasswordModalVisible(false)
              }}
            >
              取消
            </Button>
          </div>
        }
        modalRender={(modal) => (
          <div>
            <Draggable
              disabled={disabled}
              bounds={bounds}
              onStart={(event, uiData) => onStart(event, uiData)}
            >
              <div ref={draggleRef}>{modal}</div>
            </Draggable>{' '}
          </div>
        )}
      >
        {joinClassError && (
          <div className={projectStyles.joinClassErrorMsg}>{joinClassError}</div>
        )}
        <div className={projectStyles.joinClassFormItem}>
          <label className={projectStyles.joinClassFormLabel}>班级密码</label>
          <Input
            onChange={(e) => {
              inputClassRoomPassword.current = e.target.value
            }}
            placeholder="请输入班级密码"
          />
        </div>
        <div className={projectStyles.joinClassFormItem}>
          <label className={projectStyles.joinClassFormLabel}>真实姓名</label>
          <Input
            value={realName}
            onChange={(e) => {
              setRealName(e.target.value)
            }}
            placeholder="请输入真实姓名"
          />
        </div>
        <div className={projectStyles.joinClassFormItem}>
          <label className={projectStyles.joinClassFormLabel}>学号</label>
          <Input
            value={realNumber}
            onChange={(e) => {
              setRealNumber(e.target.value)
            }}
            placeholder="请输入学号"
          />
        </div>
      </Modal>

      <CoursePaymentModal
        visible={coursePaymentVisible}
        courseId={projectId}
        priceCent={pendingAccessInfo?.price_cent}
        onSuccess={() => {
          setCoursePaymentVisible(false)
          queryProject(collegeId)
        }}
        onCancel={() => {
          setCoursePaymentVisible(false)
        }}
      />
    </Layout>
  )
}

export default ProjectMainStudent
